// src/store/slices/medicineMasterSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import BaseUrl from '../../../BaseUrl';

const API_BASE_URL = BaseUrl.pharmacyurl

export const fetchMedicineMasters = createAsyncThunk(
  'medicineMaster/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await axios.get(`${API_BASE_URL}/MedicineMasters`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchMedicineMasterById = createAsyncThunk(
  'medicineMaster/fetchById',
  async (id, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await axios.get(`${API_BASE_URL}/MedicineMasters/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const createMedicineMaster = createAsyncThunk(
  'medicineMaster/create',
  async (medicineData, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await axios.post(`${API_BASE_URL}/MedicineMasters`, medicineData, {
        headers: { 
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateMedicineMaster = createAsyncThunk(
  'medicineMaster/update',
  async ({ id, medicineData }, { rejectWithValue }) => {
    console.log(JSON.stringify(medicineData,null,2))
    try {
      const token = localStorage.getItem('accessToken');
      const response = await axios.put(`${API_BASE_URL}/MedicineMasters/${id}`, medicineData, {
        headers: { 
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deleteMedicineMaster = createAsyncThunk(
  'medicineMaster/delete',
  async (id, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('accessToken');
      await axios.delete(`${API_BASE_URL}/MedicineMasters/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      return id;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const medicineMasterSlice = createSlice({
  name: 'medicineMaster',
  initialState: {
    medicines: [],
    currentMedicine: null,
    loading: false,
    error: null
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearCurrentMedicine: (state) => {
      state.currentMedicine = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch All
      .addCase(fetchMedicineMasters.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMedicineMasters.fulfilled, (state, action) => {
        state.loading = false;
        state.medicines = action.payload;
      })
      .addCase(fetchMedicineMasters.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Fetch By ID
      .addCase(fetchMedicineMasterById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMedicineMasterById.fulfilled, (state, action) => {
        state.loading = false;
        state.currentMedicine = action.payload;
      })
      .addCase(fetchMedicineMasterById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Create
      .addCase(createMedicineMaster.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createMedicineMaster.fulfilled, (state, action) => {
        state.loading = false;
        state.medicines.push(action.payload);
      })
      .addCase(createMedicineMaster.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Update
      .addCase(updateMedicineMaster.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateMedicineMaster.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.medicines.findIndex(med => med.id === action.payload.id);
        if (index !== -1) {
          state.medicines[index] = action.payload;
        }
      })
      .addCase(updateMedicineMaster.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Delete
      .addCase(deleteMedicineMaster.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteMedicineMaster.fulfilled, (state, action) => {
        state.loading = false;
        state.medicines = state.medicines.filter(med => med.id !== action.payload);
      })
      .addCase(deleteMedicineMaster.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { clearError, clearCurrentMedicine } = medicineMasterSlice.actions;
export default medicineMasterSlice.reducer;